import { api } from "./api";
import {
  ISalesPriceLimitStatus,
  IUpdateSalesPriceLimitPayload,
} from "../types/settings.type";

export async function getSalesPriceLimitStatus(): Promise<ISalesPriceLimitStatus> {
  const response = await api.get<ISalesPriceLimitStatus>("/settings/sales-price-limit");
  return response.data;
}

export async function updateSalesPriceLimitStatus(
  payload: IUpdateSalesPriceLimitPayload
): Promise<ISalesPriceLimitStatus> {
  const response = await api.post<ISalesPriceLimitStatus>("/settings/sales-price-limit", payload);
  return response.data;
}
